import React from "react";

type Topic = { id: number; title: string; path: string };

type Props = { topics: Topic[] };

function PortalRecommendedTopics({ topics }: Props) {
  if (!topics || topics.length === 0) return null;

  return (
    <div className="portalTopics">
      <p className="portalTopicsHeader">
        <i className="fa fa-lightbulb-o" aria-hidden="true" />
        おすすめのトピック
      </p>
      <ul className="portalTopicsList">
        {topics.map((topic) => (
          <li key={topic.id}>
            <a className="p_btnLarge isSubAccent" href={topic.path}>
              {topic.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PortalRecommendedTopics;
